import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import $ from 'jquery';
// Components
import UI from './Register.ui';

// Helpers
import analytics from '~/helpers/analytics';
import productHelpers from '~/helpers/product';
import validate from '~/helpers/validate_form';
import { modalResetPassword } from '~/store/Sessions/Sessions';
import { withRouter } from '#/renderer/router';

class RegisterCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      contract_id: '',
    };

    this.internalData = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      dpi: (Date.now()).toString(),
      preferredCurrency: `${process.env.NEXT_PUBLIC_CURRENCY.toUpperCase()}`,
      country: 'HN',
      birthDate: null,
      gender: null,
      passwordConfirm: '',
    };

    // Binds
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderStep2 = this.renderStep2.bind(this);
  }

  componentDidMount() {
    // analytics.checkout(1, 'register');
    document.getElementById('app').scrollIntoView(true);
    this.orderInfo();
    validate();
  }

  orderInfo = async () => {
    const [getCart] = await Promise.all([
      this.props.orderStore.getCart(),
    ]);
    //recorrer y obtener los contractID
    const contratos = [];
    getCart.data.data.items.map((value) => {
      if (value.product.items[0].contract_id !== undefined) {
        contratos.push({ contratos: value.product.items[0].contract_id });
      }
      return value;
    });
    //console.log(contratos);
    const tienePospago = getCart.data.data.items.some(it => productHelpers.tipo(it.product) === 'POSPAGO');
    //console.log(tienePospago);
    if (tienePospago === true) {
      this.setState({ contract_id: contratos });
    } else {
      this.setState({ contract_id: 0 });
    }
  }

  handleChange(e, data) {
    const keys = data.split('.');
    const registerForm = this;
    registerForm[keys[0]][keys[1]] = e.target.value;
    this.setState(registerForm);
  }

  handleData() {
    const query = {
      ...this.internalData,
      email: this.internalData.email.toUpperCase(),
    };

    delete query.passwordConfirm;

    this.props.sessionStore.personRegister(query).then((res) => {
      if (res.success && res.action === 'personRegister') {
        /* let medalia_email;
        let medalia_name;
        if (query) {
          medalia_email = query.email.toLowerCase();
          medalia_name = `${query.firstName} ${query.lastName}`;
        } else {
          medalia_email = null;
          medalia_name = null;
        }
        const medalia_user_login = true;
        const medalia_order_id = null;
        const medalia_order_state = null;
        const medalia_order_items = null;
        localStorage.setItem('medallia_email', medalia_email);
        localStorage.setItem('medallia_user_login', medalia_user_login);
        localStorage.setItem('medallia_name', medalia_name);
        localStorage.setItem('medallia_order_id', medalia_order_id);
        localStorage.setItem('medallia_order_state', medalia_order_state);
        localStorage.setItem('medallia_order_items', medalia_order_items); */
        analytics.usuarioCreado(query.firstName, query.lastName);
        this.props.history.push('/checkout/address');
      } else if (!res.success && res.action === 'personRegister') {
        if (res.error.status === 500) {
          this.setState({ error: 'Error al crear una cuenta, contacta a soporte.' });
        } else if (res.error.status === 400) {
          this.setState({ error: <span className="session" onClick={modalResetPassword} dangerouslySetInnerHTML={{ __html: res.error.data.errors[0].errorMessage }} /> });
        } else if (res && res.error && res.error.data && res.error.data.errors && res.error.data.errors[0].errorMessage) {
          const cleanError = res.error.data.errors[0].errorMessage.replace('MCV2_AM_RU_ERR_1: Error, usuario ya existe.', 'Ese usuario ya existe');
          this.setState({ error: cleanError });
        } else {
          this.setState({ error: 'Ha ocurrido un error.' });
        }
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const isIE = (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1);
    if (isIE) this.handleData();
    else if (!isIE && $("form[name='registerCheckout']").valid()) this.handleData();
  }

  renderStep2 = (e) => {
    e.preventDefault();
    this.props.history.push('/cart');
  }

  render() {
    return (
      <UI
        registerForm={this.internalData}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        renderStep2={this.renderStep2}
        error={this.state.error}
        contract_id={this.state.contract_id}
      />
    );
  }
}

RegisterCheckout.propTypes = {
  sessionStore: PropTypes.shape({
    personRegister: PropTypes.func,
  }).isRequired,
};

export default inject(
  'paymentsStore',
  'orderStore',
  'sessionStore',
  'accountStore',
  'catalogStore',
)(observer(withRouter(RegisterCheckout)));
